// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__ofjh6","title":"style_title__DQwGy","slogan":"style_slogan__IQVhm"};